/**
 * 定义路径s
 */
const PATH = 'design_'
/*
包含n个mutation的type名称常量
 */
export const SAVE_DESIGN_SRC = PATH + 'save_design_src'
export const SAVE_DESIGN_REF = PATH + 'save_design_ref'
export const SAVE_DESIGN_PAGE_ID = PATH + 'save_design_page_id'
export const REFRESH_PAGE = PATH + 'refresh_page'



// WEBPACK FOOTER //
// ./src/store/mutations/design/type.js